/**
 * The last card, on every page.
 *
 * This is the second and final place the corner brackets are spent — the hero
 * figure is the first. Two uses across a page this long is what keeps the device
 * meaning "look here" rather than becoming the page's border style.
 *
 * The paragraph under the heading is the one piece of copy on this site that
 * exists to *narrow* what is being claimed rather than to widen it: Kimene runs
 * on the customer's own infrastructure and manages the customer's own provider
 * accounts. It is not a service that shares credentials, not a multi-tenant
 * proxy, and not a way around a provider's limits. Saying so at the point
 * somebody decides to get in touch is the honest place to say it.
 *
 * Both actions are now people rather than URLs into a source tree: talk to us,
 * or telephone. A closing card that offered a repository was closing on the
 * wrong ask.
 */
import { PressPlate } from '../kit'
import { useLocale, useT } from '../i18n/context'
import { COMPANY } from '../data/links'
import { pathFor } from '../routes'
import './Closing.css'

export function Closing() {
  const t = useT()
  const locale = useLocale()

  return (
    <section className="kl-section kl-closing" aria-labelledby="closing-title">
      <div className="kl-inner">
        <div className="kl-closing__card k-frame">
          <h2 id="closing-title" className="kl-closing__title">
            {t('cta.title')}
          </h2>
          <p className="kl-closing__sub">{t('cta.sub')}</p>
          <div className="kl-closing__actions">
            <PressPlate href={pathFor(locale, 'contact')}>{t('cta.primary')}</PressPlate>
            <PressPlate href={COMPANY.phoneHref} tone="ghost">
              {t('cta.secondary')}
            </PressPlate>
          </div>
        </div>
      </div>
    </section>
  )
}
